var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeCloseIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4200439453125 8.4200439453125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05000019,6.10999966 C0.400000215,5.45999968 0,4.56999993 0,3.57999992 C0,1.5999999 1.5999999,0 3.57999992,0 C4.56999993,0 5.45999968,0.400000215 6.10999966,1.05000019 L1.05000019,6.10999966 Z",
    stroke: "#AAB3C2",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: " 0.0 0.0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.214965820312499 3.72998046875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6049995,2.03999996 C13.8549995,0.719999909 11.8549998,0 9.78499985,0 C6.25499988,0 2.96499991,2.07999992 0.674999952,5.67999983 C-0.225000024,7.08999979 -0.225000024,9.46000087 0.674999952,10.8700008 C1.46499997,12.1100008 2.38499975,13.1800009 3.38499975,14.0400009",
    stroke: "#AAB3C2",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: " 0.0 0.0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4200439453125 7.9300537109375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.6000004 C1.13999999,12.0800004 2.3499999,12.3400002 3.57999992,12.3400002 C7.1099999,12.3400002 10.4000006,10.2600002 12.6900005,6.66000032 C13.5900005,5.25000036 13.5900005,2.87999976 12.6900005,1.46999979 C12.3600005,0.949999809 12,0.460000008 11.6299992,0",
    stroke: "#AAB3C2",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: " 0.0 0.0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.68994140625 12.699951171875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.82000065,0 C2.56000066,1.40999997 1.40999997,2.56000066 0,2.82000065",
    stroke: "#AAB3C2",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: " 0.0 0.0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 14.530029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47000027,0 L0,7.47000027",
    stroke: "#AAB3C2",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: " 0.0 0.0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.530029296875 2.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47000027,0 L0,7.47000027",
    stroke: "#AAB3C2",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: " 0.0 0.0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseIc);
export default __webpack_public_path__ + "static/media/eye_close_ic.160348110e6b3cf2aa4a06c467701eec.svg";
export { ForwardRef as ReactComponent };